/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusErlassVerlaufListResponseDto } from '../../models/lexplus-erlass-verlauf-list-response-dto';
import { LexplusVerlaufFilterEnum } from '../../models/lexplus-verlauf-filter-enum';

export interface ErlassDetailControllerGetErlassVerlaufV1$Params {
  erlassID: number;
  filter?: LexplusVerlaufFilterEnum;
  page?: number;
  limit?: number;
}

export function erlassDetailControllerGetErlassVerlaufV1(http: HttpClient, rootUrl: string, params: ErlassDetailControllerGetErlassVerlaufV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusErlassVerlaufListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, erlassDetailControllerGetErlassVerlaufV1.PATH, 'get');
  if (params) {
    rb.path('erlassID', params.erlassID, {});
    rb.query('filter', params.filter, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusErlassVerlaufListResponseDto>;
    })
  );
}

erlassDetailControllerGetErlassVerlaufV1.PATH = '/v1/compliance/erlasse/{erlassID}/verlauf';
